/**
 * Static class which gathers functionality for `hideable fields`
 */
class FormbuilderHideable {
    static opensAttr = 'opens';                      // Decides which filed to show
    static opensValueAttr = 'opensvalue';                  // Decides on which value show it
    static openNameAttr = 'openname';                    // Sets name by which openers can find it
    static parentClass = 'form-group';
    static parentHideClass = 'hideable-parent';
    static validationAttr = 'data-initial-constraints';
    static requiredAttr = 'required';
    static notEmptyAttr = 'cvf_not-empty';

    constructor() {
        throw new Error('FormbuilderHideable is a static class and cannot be initialized');
    }

    /**
     * Sets up event listener when page was downloaded and parsed which calls then `setup` static method
     */
    static init() {
        window.addEventListener('DOMContentLoaded', (e) => {
            FormbuilderHideable.setup.bind(FormbuilderHideable)(e)
        });
    }

    /**
     * Method which gathers `openers` and `hideable` then creates map of `hideables` which is later used by `openers` to open correct fields.
     * At last we add to `openers` listener `onchange` with method `openerValueChange`.
     * @param  {Event} e
     */
    static setup(e) {
        const openers = document.querySelectorAll('[' + this.opensAttr + ']');
        const openName = document.querySelectorAll('[' + this.openNameAttr + ']');

        //console.log("openName")//to co jest otweirane
        //console.log(openName)
        const map = {};
        let name = "";
        let oldOpenMulti = '';
        let visible = false;
        openName.forEach(function (input) {
            const parent = this.findFieldRoot(input, [input]);
            parent.parentElement.classList.add(this.parentHideClass);

            const validation = input.getAttribute(this.validationAttr);
            input.removeAttribute(this.validationAttr);

            const required = input.getAttribute(this.requiredAttr);
            input.removeAttribute(this.requiredAttr);

            const notEmpty = input.classList.contains(this.notEmptyAttr);
            input.classList.remove(this.notEmptyAttr);
            name = input.getAttribute('openname');
            let checkNameArray = [];
            checkNameArray = this.checkName(name);

            //console.log("===================");

            if (checkNameArray.length > 1) {

                //console.log("checkNameArray + name " + name)

                //console.log(checkNameArray)
                checkNameArray.forEach(function (checkName) {
                    oldOpenMulti = input.getAttribute("openname");
                    input.setAttribute("openname", checkName);


                    // input.setAttribute("opennameMulti", oldOpenMulti);

                    if (typeof map[checkName] == 'undefined') {
                        map[checkName] = [];
                    }
                    map[checkName].push({parent, input, validation, required, notEmpty});
                })
                input.setAttribute("openname", oldOpenMulti);
            } else {
                if (typeof map[name] == 'undefined') {
                    map[name] = [];
                }
                map[name].push({parent, input, validation, required, notEmpty});
                name = "";
            }
            //console.log(map)
        }.bind(this));

        openers.forEach(function (input) {
            const essentials = Object.assign(this, {origin: input, map});
            if (input.type === 'checkbox') {
                input.value = 0;
                input.addEventListener('change', function () {
                    if (input.checked) {
                        input.value = 1;
                        if (input.classList.contains('delete-no')) {
                            input.parentElement.querySelector('.checkbox_radio_label').textContent = 'Posiadam numer PESEL';
                        }
                    } else {
                        input.value = 0;
                        if (input.classList.contains('delete-no')) {
                            input.parentElement.querySelector('.checkbox_radio_label').textContent = 'Nie posiadam numeru PESEL';
                        }
                    }
                });
            }

            if (input.type === 'select-one' || input.type === 'checkbox') {
                this.openerValueChange(input);
                input.addEventListener('change', this.openerValueChange.bind(essentials, input));
                this.addScroll(input);
            } else {
                input.querySelectorAll('input').forEach(el => {
                    this.openerValueChange(input);

                    el.addEventListener('change', this.openerValueChange.bind(essentials, input));
                    this.addScroll(el);
                });
            }
        }.bind(this));
    }

    /**
     * Finds the root container of the field (container which hold all the input nodes)
     * @param  {Node}  input
     * @param  {Array} [previousInputs=[]] Previous inputs found on the way to the root
     * @return {Node}                      Root container
     */
    static findFieldRoot(input, previousInputs = []) {
        if (input.parentElement == document.body) {
            throw new Error('Parent container was not found');
        }

        if (input.parentElement.classList.contains(this.parentClass)) {
            if (input.parentElement.nodeName === 'FIELDSET' || input.parentElement.nodeName === 'DIV') {
                return previousInputs[0];
            }
            return input;
        }

        return this.findFieldRoot(input.parentElement, [input, ...previousInputs]);
    }

    /**
     * Method called when input value got changed.
     * To work it requires to have :
     * - origin - origin input
     * - map - map of all related input that could appear
     * Method check if value inside the input matches `opensvalue` and if so shows all fields with `openname` equal to this input `opens`.
     * It also removes any validation on the input when hidden.
     */
    static openerValueChange(input) {

        let value = input.value;
        let listOpensValue = (input.getAttribute(this.opensValueAttr)).split(',');

        let opensAttr = input.getAttribute(this.opensAttr);

        let opensName = '';
        if (typeof input != 'select-one') {
            let listInput = (Array.from(input.getElementsByTagName('input')));
            listInput.forEach(input => {
                if (input.checked) {
                    value = input.value;
                }
            });
        }


        let field_to_visible = '';

        listOpensValue.forEach(opensValue => {
            opensName = opensAttr + '[' + opensValue + ']';


            if (typeof this.map[opensName] == 'undefined') {
                return;
            }

            this.map[opensName].forEach(field => {

                if (opensValue === value) {

                    this.doVisible(field);

                    field_to_visible = opensName;

                } else {

                    field.parent.parentElement.classList.remove('visible');
                    field.input.removeAttribute(this.validationAttr);
                    field.input.removeAttribute(this.requiredAttr);
                    field.input.classList.remove(this.notEmptyAttr);

                    if (field.input.querySelectorAll('input[type=radio]')) {
                        let noClick = false;
                        if (field.input.classList.contains('div-custom-radio')) noClick = true;

                        field.input.querySelectorAll('input[type=radio]').forEach(radioInput => {
                            radioInput.checked = false;
                            if (noClick) {
                                radioInput.nextElementSibling.classList.add('noClick');
                            }
                        })
                    }
                    if (field.input.tagName === 'INPUT' && field.input.type === 'checkbox') {
                        field.input.checked = false;
                    } else if (field.input.tagName === 'INPUT') {
                        field.input.value = '';
                    }
                }

            });

        });


        if (field_to_visible) {
            this.map[field_to_visible].forEach(fieldToVisible => {
                    this.doVisible(fieldToVisible);

                }
            );
        }

    }

    static addScroll(element) {
        element.addEventListener('change', function () {
            if (element.type === 'select-one' || element.type === 'checkbox' || element.type === 'radio') {
                if (element.closest('[opensvalue]').classList.contains('scroll-down-opens')) {
                    window.scrollBy(0, 650);
                }
            } else {
                if (element.classList.contains('scroll-down-opens')) {
                    window.scrollBy(0, 650);
                }
            }
        });
    }

    static checkName(inputString) {
        let outputArray = [];

        let regex = /(\w+)\[([^\]]*)\]/g;
        let match;
        while ((match = regex.exec(inputString)) !== null) {
            let name = match[1]; // openname
            let elements = match[2].split(","); // Elementy wewnątrz nawiasów kwadratowych, rozdzielone przecinkami

            elements.forEach(function (element) {
                outputArray.push(name + "[" + element + "]");
            });
        }

        // console.log(outputArray);
        return outputArray;
    }

    static doVisible(field) {
        field.parent.parentElement.classList.add('visible');


        if (field.validation) {
            field.input.setAttribute(this.validationAttr, field.validation);
        }

        if (field.required) {
            field.input.setAttribute(this.requiredAttr, field.required);
        }

        if (field.notEmpty) {
            field.input.classList.add(this.notEmptyAttr);
        }
    }
}

FormbuilderHideable.init();
